'use strict';

/**
 * Test whether a value is a collection: an Array or Matrix
 * @param {*} x
 * @returns {boolean} isCollection
 */
module.exports = function isCollection (x) {
  return (Array.isArray(x) || (x && x.isMatrix === true));
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/utils/collection/isCollection.js
// module id = 124
// module chunks = 0